import { ChipTypeMap } from '@mui/material';
import { StyledPopper } from '../../menu/Popper/Popper';
import { InlineAutocomplete } from './InlineAutocomplete';
import { AutocompleteProps } from '../Autocomplete/Autocomplete';

export function InlineAutocompleteWithExternalTrigger<
  A,
  B extends boolean | undefined,
  C extends boolean | undefined,
  D extends boolean | undefined,
  E extends React.ElementType = ChipTypeMap['defaultComponent']
>(
  props: Omit<AutocompleteProps<A, B, C, D, E>, 'onChange'> & {
    onChange: (value: unknown) => void;
    target: string;
    open: boolean;
    close: VoidFunction;
    dataSource?: (params: unknown) => Promise<unknown>;
  }
) {
  const { target, open, close, dataId, ...rest } = props;
  return (
    <StyledPopper
      placement='bottom-start'
      target={target}
      open={open}
      onClose={() => {
        close();
      }}
    >
      <InlineAutocomplete {...rest} dataId={dataId} />
    </StyledPopper>
  );
}
